var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeClosed = function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    d: "M22.02 1.002S17.301 7.168 11.5 7.168C5.7 7.168.78.871 1.009 1.002M11.5 9.89V7.168M21.086 5.66l-1.261-2.133M16.798 8.71l-.732-2.526M6.204 8.71l.757-2.526M1.916 5.66l1.26-2.133"
  })));
};
export default SvgEyeClosed;